{
  "adobeExperienceCloudNoOrgsSelect": "Selecionar outra conta de organização",
  "appSwitcherLinkOutIconLabel": "Abre em uma nova janela",
  "feedback button default": "Feedback",
  "help": "Ajuda",
  "launchsidebar": "Iniciar barra lateral",
  "more actions": "Mais ações",
  "searchButton": "Pesquisar",
  "solutionSwitcher": "Alternar para outra solução",
  "solutionSwitcherList": "Lista de aplicativos",
  "solutionSwitcherPopover": "Popover da lista de aplicativos"
}
